import * as Types from '../../graphql/types'

import { gql } from 'apollo-boost'
import * as ApolloReactCommon from '@apollo/react-common'
import * as ApolloReactHooks from '@apollo/react-hooks'
const defaultOptions = {}
export type PostponeLetterRequestMutationVariables = Types.Exact<{
  letterRequestId: Types.Scalars['Int']
}>

export type PostponeLetterRequestMutation = {
  __typename?: 'Mutation'
  postponeLetterRequest: { __typename?: 'LetterRequest'; id: number }
}

export const PostponeLetterRequestDocument = gql`
  mutation PostponeLetterRequest($letterRequestId: Int!) {
    postponeLetterRequest(letterRequestId: $letterRequestId) {
      id
    }
  }
`
export type PostponeLetterRequestMutationFn = ApolloReactCommon.MutationFunction<
  PostponeLetterRequestMutation,
  PostponeLetterRequestMutationVariables
>
export function usePostponeLetterRequestMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    PostponeLetterRequestMutation,
    PostponeLetterRequestMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    PostponeLetterRequestMutation,
    PostponeLetterRequestMutationVariables
  >(PostponeLetterRequestDocument, options)
}
export type PostponeLetterRequestMutationHookResult = ReturnType<
  typeof usePostponeLetterRequestMutation
>
export type PostponeLetterRequestMutationResult =
  ApolloReactCommon.MutationResult<PostponeLetterRequestMutation>
export type PostponeLetterRequestMutationOptions = ApolloReactCommon.BaseMutationOptions<
  PostponeLetterRequestMutation,
  PostponeLetterRequestMutationVariables
>
